import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Custom error thrown when cancelling commands. Allows the caller to act differently if needed.
 * @class
 * @param {Command} command
 */
var CancelledCommandException = /*#__PURE__*/function () {
  function CancelledCommandException(command) {
    _classCallCheck(this, CancelledCommandException);
    this.command = command;
    this.isCancelledCommandException = true;
  }
  _createClass(CancelledCommandException, [{
    key: "toString",
    value: function toString() {
      return "Cancelled command ".concat(this.command.requester.id, "/").concat(this.command.layer.id);
    }
  }]);
  return CancelledCommandException;
}();
export default CancelledCommandException;